import React,{ useMemo } from 'react';
import './coach-details.module.scss';
import { Checkbox } from '@mui/material';
import { groupBy } from 'lodash-es';
import { mediaUrl } from 'src/shared/config';
import * as Config from 'src/shared/config';
import { breakpoints, useMediaQuery } from 'src/shared/hooks/use-media-query';
import { EventDateConflicts } from './event-date-conflicts';

const CoachDetails = ({
  coachesConflicts,
  disableActions,
  eventDates,
  handleSelect,
  isBulk,
  item,
  selectedCoaches,
}) => {
  const adminUrl = Config.ADMIN_URLS[ENVIRONMENT];

  const { coach } = item;
  const { fullName, nickName, picture = {} } = coach || {};
  const { image } = picture || {};
  const { events = [] } = item;

  const assignedToCurrentEvent = useMemo(() => {
    return events.some((eventDate) =>
      eventDates
        .map((el) => Number(el.event.id))
        .includes(Number(eventDate?.event?.id)),
    );
  }, [events, eventDates]);

  const eventData = useMemo(() => {
    return events.find((eventDate) =>
      eventDates
        .map((el) => Number(el.event.id))
        .includes(Number(eventDate?.event?.id)),
    );
  }, [events, eventDates]);

  const categories = useMemo(() => {
    const { categoryValues = [] } = coach || {};
    if (categoryValues.length === 0) return [];
    const info = [];
    const customFields = categoryValues.filter(
      (categoryValue) => categoryValue.categoryType === 'customField',
    );
    const groupedByCategory = groupBy(customFields, 'categoryId');
    for (const [, categoryValues] of Object.entries(groupedByCategory)) {
      info.push(
        ...categoryValues.map((categoryValue) => {
          const { categoryOption = {} } = categoryValue || {};
          const { name } = categoryOption || {};
          return name;
        }),
      );
    }
    const tags = categoryValues.filter(
      (categoryValue) => categoryValue.categoryType === 'tag',
    );
    if (tags.length > 0) {
      info.push(...tags.map((tag) => tag?.category?.name));
    }
    return info.filter(Boolean);
  }, [coach]);

  const isSelected = useMemo(() => {
    return selectedCoaches.some(
      (selectedCoach) => selectedCoach.id === coach.id,
    );
  }, [coach.id, selectedCoaches]);
  const isMobile = useMediaQuery(
    [breakpoints.mobile, breakpoints.tablet, breakpoints.desktop],
    [true, true, false],
  );
  return (
    <div className={"coachDetailsContainer"}>
      <div className={"avatarRow"}>
        {!assignedToCurrentEvent && (
          <Checkbox
            checked={isSelected}
            className={isMobile ? 'tw-hidden' : ''}
            disabled={disableActions}
            onChange={() => handleSelect(coach)}
          />
        )}

        <img
          alt=""
          className="avatar"
          src={image ? mediaUrl(image) : '/image/generic-avatar.png'}
        />
        <a
          target="_blank"
          href={`${adminUrl}/users/${coach?.id || coach?.assigneeId}/availability`} rel="noreferrer"
        >
          <p className="coachName">{fullName}</p>
          <p className="coachName m-0">{nickName ? ` (${nickName})` : ''}</p>
        </a>
      </div>
      <div className="detailsRow">
        <div className={"categoryOptions"}>
          {categories.map((category, index) => (
            <div className={"pil"} key={index + category}>
              {category}
            </div>
          ))}
        </div>
      </div>
      {assignedToCurrentEvent && (
        <div className={"redPil"}>
          Already staffed to{' '}
          {isBulk
            ? eventData?.event?.effectiveName || eventData?.event?.label
            : 'this event'}
        </div>
      )}
      {!assignedToCurrentEvent && (
        <div className={"conflictContainer"}>
          <EventDateConflicts
            coachId={coach?.id}
            coachesConflicts={coachesConflicts}
          />
        </div>
      )}
    </div>
  );
};

export default CoachDetails;
